var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c("div", { attrs: { id: "namoEditor" } }, [
      _c("textarea", {
        staticStyle: { width: "100%", height: "400px", "font-size": "11pt" },
        attrs: {
          id: _vm.getEditorId,
          name: _vm.getEditorId,
          alt: "initText",
          title: "initText"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3308c1c3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3308c1c3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/common/CrossEditor.vue
// module id = uaHf
// module chunks = 0